//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { STATUS, getConfig } from '../const'
import Doing from '../_doing'
import Done from '../_done'
import Service from '@/service'
import LocalData from '@/utils/local_data'

let SHARE_IMG
let NEED_SHARE_IMG
let SHARE_TEXT
let NEED_SHARE_TEXT

export default {
    components: {
        Doing,
        Done
    },
    data () {
        return {
            verify_type: '',
            status: STATUS.DOING,
            zone: '',
            visit_time: '',
            questions: [],
            need: false,
            headimgurl: '',
            zone_ids: '',
            now: '',
            need_result_tx: '无房家庭资格'
        }
    },
    destroyed () {
        console.error('onUnload')
        this.reset()
    },
    created () {
        console.error('onLoad')
        const { verify_type, now } = this.$route.params
        this.verify_type = verify_type || ''
        this.now = now
        getConfig().then(({ share_img, share_text, need_share_img, need_share_text, need_result_tx }) => {
            SHARE_TEXT = share_text
            SHARE_IMG = share_img
            NEED_SHARE_IMG = need_share_img
            NEED_SHARE_TEXT = need_share_text
            this.need_result_tx = need_result_tx
        })
        Service.getUserInfo().then(({ headimgurl }) => {
            this.headimgurl = headimgurl
        })
    },
    methods: {
        changeStatus (status) {
            this.status = status
        },
        goStart () {
            this.reset(this.verify_type)
        },
        goDoing () {
            this.changeStatus(STATUS.DOING)
        },
        goDone (zone, visit_time, questions, need, zone_ids) {
            this.zone = zone
            this.visit_time = visit_time
            this.questions = questions
            this.need = need
            this.zone_ids = zone_ids
            this.changeStatus(STATUS.DONE)
        },
        reset (verify_type = 'init') {
            this.zone = ''
            this.zone_ids = ''
            this.questions = []
            this.verify_type = verify_type
            this.changeStatus(STATUS.DOING)
        }
    },
}
